export default "__VITE_ASSET__BhvEDmGA__"